// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Icons } from "../../spinner";

interface EmployeeData {
  total_de_funcionarios_no_periodo: number;
  total_de_afastados_no_periodo: number;
  tipos_afastamentos_no_periodo: Record<string, number>;
  funcionarios: Array<{
    id: number;
    filial: string;
    matricula: string;
    centro_custo: string;
    cpf: string;
  }>;
}

const getLevelOption = () => ({
  itemStyle: {
    borderColor: "#fff",
  },
  levels: [
    {
      itemStyle: { borderWidth: 0, gapWidth: 0 },
      upperLabel: { show: false },
    },
    {
      itemStyle: { borderColor: "#555", borderWidth: 5, gapWidth: 1 },
      emphasis: { itemStyle: { borderColor: "#ddd" } },
    },
    {
      colorSaturation: [0.35, 0.5],
      itemStyle: {
        borderWidth: 5,
        gapWidth: 1,
        borderColorSaturation: 0.6,
      },
    },
  ],
});

const transformEmployeeData = (data: EmployeeData) => {
  if (!data) return [];

  const ativos =
    data.total_de_funcionarios_no_periodo - data.total_de_afastados_no_periodo;

  const transformedData = [
    {
      name: "Ativos",
      value: ativos,
      itemStyle: { color: "#91cc75" },
    },
  ];

  const afastamentosMap = {
    Férias: "#5470c6",
    "Afastamento Temporário por Doença": "#fac858",
  };

  Object.entries(data.tipos_afastamentos_no_periodo).forEach(([tipo, quantidade]) => {
    transformedData.push({
      name: tipo,
      value: quantidade,
      itemStyle: {
        color: afastamentosMap[tipo as keyof typeof afastamentosMap] || "#fac858",
      },
    });
  });

  return transformedData;
};

export function EmployeeStatus() {
  const [options, setOptions] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<any>(null);
  const { employeeStatusData, loadingChartCurrentEmployeesWorking } = useStoreTimToa(
    (state) => state
  );

  const updateOptions = () => {
    const totalEmployees = employeeStatusData?.total_de_funcionarios_no_periodo || 0;
    const transformedData = transformEmployeeData(employeeStatusData);

    const option = {
      mouseWheel: { zoomSensitivity: 0 },
      legend: {
        top: "2%",
        left: "right",
        orient: "horizontal",
        textStyle: { color: "#fff" },
      },
      title: {
        text:
          totalEmployees > 0
            ? `Total de Funcionários: ${totalEmployees}`
            : "Carregando...",
        left: "center",
        top: "3%",
        textStyle: { color: "#fff", fontSize: 14 },
      },
      tooltip: {
        formatter: (info: any) => {
          const value = info.value;
          if (!totalEmployees) return `${info.name}<br/>Quantidade: ${value}`;
          const percent = ((value / totalEmployees) * 100).toFixed(2);
          return `${info.name}<br/>Quantidade: ${value}<br/>Percentual: ${percent}%`;
        },
      },
      series: [
        {
          type: "treemap",
          visibleMin: 300,
          data: transformedData,
          leafDepth: 1,
          zoomable: false,
          breadcrumb: { show: false },
          label: {
            show: true,
            formatter: (params: any) => `${params.name}\n${params.value}`,
            fontSize: 12,
            color: "#fff",
          },
          upperLabel: { show: true, height: 30 },
          ...getLevelOption(),
        },
      ],
    };

    setOptions(option);
  };

  useEffect(() => {
    if (employeeStatusData) {
      updateOptions();
    }
  }, [employeeStatusData]);

  return (
    <>
      {employeeStatusData ? (
        <div className="bg-gray-500 shadow-md rounded-sm">
          <ReactECharts
            option={options}
            style={{ height: "450px", width: "100%" }}
            onEvents={{
              click: (params) => {
                if (params.data) {
                  setSelectedData(params.data);
                  setModalOpen(true);
                }
              },
            }}
          />
        </div>
      ) : loadingChartCurrentEmployeesWorking ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold">
            SEM DADOS
          </p>
        </div>
      )}

      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="max-w-[1400px]">
          <DialogHeader>
            <DialogTitle>{selectedData?.name}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="flex gap-4">
              <p>Quantidade: {selectedData?.value}</p>
              <p>
                Percentual:{" "}
                {employeeStatusData?.total_de_funcionarios_no_periodo > 0
                  ? (
                      ((selectedData?.value || 0) /
                        employeeStatusData.total_de_funcionarios_no_periodo) *
                      100
                    ).toFixed(2)
                  : 0}
                %
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
